import { render, staticRenderFns } from "./familylinkSettings.vue?vue&type=template&id=6dcf4b92&scoped=true&"
import script from "./familylinkSettings.vue?vue&type=script&lang=js&"
export * from "./familylinkSettings.vue?vue&type=script&lang=js&"
import style0 from "./familylinkSettings.vue?vue&type=style&index=0&id=6dcf4b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcf4b92",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dcf4b92')) {
      api.createRecord('6dcf4b92', component.options)
    } else {
      api.reload('6dcf4b92', component.options)
    }
    module.hot.accept("./familylinkSettings.vue?vue&type=template&id=6dcf4b92&scoped=true&", function () {
      api.rerender('6dcf4b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/familylinkSettings.vue"
export default component.exports